'use client';

import Banner from '@savvy-kit/patterns/banner';

import type { TaxEnrollmentBannerStatus } from '@savvy/constants/generated/gql-enums';

const taxActionNeeded: TaxActionNeeded = {
  signature_needed: {
    title: 'Action required',
    description:
      "This household hasn't signed their tax forms yet. Complete signatures before March 31st to avoid missing this tax year's filing.",
    actionVariant: 'warning',
  },
  filing_needed: {
    title: 'Action required',
    description:
      "This household hasn't completed their filing yet. Reach out to your CSA to adjust your client's enrollment.",
    actionVariant: 'warning',
  },
};

type TaxActionNeeded = Record<
  Exclude<TaxEnrollmentBannerStatus, 'none'>,
  {
    title: string;
    description: string;
    actionVariant: 'default' | 'warning';
  }
>;

type TaxEnrollmentBannerProps = {
  readonly bannerStatus: TaxEnrollmentBannerStatus;
};

export function TaxEnrollmentBanner({ bannerStatus }: TaxEnrollmentBannerProps) {
  if (bannerStatus === 'none') {
    return null;
  }

  return (
    <Banner
      variant={taxActionNeeded[bannerStatus].actionVariant}
      title={taxActionNeeded[bannerStatus].title}
      description={taxActionNeeded[bannerStatus].description}
    />
  );
}
